import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';

interface AnalyticsState {
  activeViews: {
    overview: boolean;
    eventBreakdown: boolean;
    trafficSources: boolean;
    visitorDemographics: boolean;
  };
}

const initialState: AnalyticsState = {
  activeViews: {
    overview: true,
    eventBreakdown: false,
    trafficSources: false,
    visitorDemographics: false,
  },
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    toggleView: (
      state,
      action: PayloadAction<keyof AnalyticsState['activeViews']>
    ) => {
      // Only update if we're actually changing to a different view
      if (!state.activeViews[action.payload]) {
        // Create new state object
        const newActiveViews = {
          overview: false,
          eventBreakdown: false,
          trafficSources: false,
          visitorDemographics: false,
          [action.payload]: true
        };

        // Only update if the state would actually change
        if (!_.isEqual(state.activeViews, newActiveViews)) {
          state.activeViews = newActiveViews;
        }
      }
    },
  },
});

export const { toggleView } = analyticsSlice.actions;
export default analyticsSlice.reducer;
